import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import {
  Button, Card, Col, Container, Input, Label, Row, TabContent, TabPane,
  Nav,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  NavItem,
  NavLink
} from "reactstrap"
import classnames from "classnames"

import { map } from "lodash"
import axios from "axios"
import { API_URL } from "helpers/app_url"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EmailToolbar from "./email-toolbar"
import { Formik, Form, Field, ErrorMessage } from 'formik';

import * as Yup from 'yup';
import moment from "moment";
import EmailSideBar from "./email-sidebar"
import SafeHTML from "components/buttons/SafeHTML"
class EmailSent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      activeTab: "1",
      resultArray: [],
      isLoading: false,
      agentData:'',
      currentPage: 1,
      totalPages: 1
    }
    this.togglemodal.bind(this)
    this.toggleTab = this.toggleTab.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    if (!this.state.agentData) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const userId = localStorage.getItem("userId");
    
    this.setState({ isLoading: true });
    axios.get(`${API_URL}Agent/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      const agentData = res.data;
      this.setState({ agentData }, () => {
        const agentId = this.state.agentData.agentId;
        axios.get(`${API_URL}Gmail/SyncGmails/${agentId}/0`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
          if (response.data === 'Success') {
       
            this.fetchInboxMails(agentId, this.state.currentPage);
          }
        })
        .catch(error => {
          console.error('Error syncing gmails:', error);
          this.setState({ isLoading: false });
        });
      });
    })
    .catch(error => {
      console.error('Error fetching agent data:', error);
      this.setState({ isLoading: false });
    });
    }
  }
  fetchInboxMails(agentId, page) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    axios.get(`${API_URL}Gmail/GetMailFromByAgentPagination/${agentId}/${page}/20/true/false`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(secondResponse => {
      
      
      this.setState({
        inboxMails: secondResponse.data.items, 
        totalPages: secondResponse.data.totalPages || 1, 
        isLoading: false,
      });
    })
    .catch(error => {
      console.error('Error fetching data from second API:', error);
      this.setState({ isLoading: false });
    });
  }
  handleNextPage = () => {
    const { currentPage, totalPages, agentData } = this.state;
    if (currentPage < totalPages) {
      this.setState({ currentPage: currentPage + 1, isLoading: true }, () => {
        this.fetchInboxMails(agentData.agentId, this.state.currentPage);
      });
    }
  };

  
  handlePreviousPage = () => {
    const { currentPage, agentData } = this.state;
    if (currentPage > 1) {
      this.setState({ currentPage: currentPage - 1, isLoading: true }, () => {
        this.fetchInboxMails(agentData.agentId, this.state.currentPage);
      });
    }
  };


  toggleTab(tab) {

    if (this.props.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }
  
  handleSubmit(value) {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const payload = {
      //name: value.name,
      //from:value.from,
      to: value.to,
      subject:value.subject,
      body:value.body,
      agentId:value.agentId
    }
    axios.post(`${API_URL}Gmail`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      
      this.setState({ isLoading: false });
      this.togglemodal();
    })
    .catch(error => {
      console.error("API Error:", error);
      this.setState({ isLoading: false });
    });
  }
  render() {
    
    //meta title
    document.title = "Email | Realty Space";

    const { inboxMails, isLoading, currentPage, totalPages} = this.state;
   
    const validationSchema = Yup.object().shape({
      to: Yup.string().email('Invalid email format').required('Email is required'),
      subject: Yup.string().required('Subject is required'),
      message: Yup.string().required('Message is required'),
    });
    //
    
    return (
      <React.Fragment>
         {isLoading ? (
                    <div className="rs-loader-overlay">
                    <div className="rs-loader"></div>
                    </div>
                ) : null}
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Row className="project-header">
            <Col xl="7">
            <Breadcrumbs title="Email" breadcrumbItem="Inbox" />
           </Col>
            <Col xl="5">
            <div className="pt-2 float-end mt-2">
                  
                  <div className="">
                   
                  
                  </div>
                 
                </div>
          
           </Col>
           </Row>
           
           
            <Row className="mt-20">
              <Col xs="12">
                {/* Render Email SideBar */}
                <EmailSideBar agentData={this.state?.agentData?.agentId} />
                {/* <div className="email-leftbar card">
              
                </div> */}
                <div className="email-rightbar mb-3" style={{marginLeft:0}}>
                  <Card>
                    {/* Render Email Top Tool Bar */}
                    <EmailToolbar />
                    <TabContent
                      activeTab={this.state.activeTab}
                    >
                      <TabPane tabId="1">
                      <ul className="message-list">
                      {map(inboxMails, (inbox, key) => {
                        const createdOnDate = moment(inbox.createdOn);
                        const isToday = createdOnDate.isSame(moment(), 'day');

                        return (
                          <li key={key} className={inbox.read ? "" : ""}>
                            <div className="col-mail col-mail-1">
                              <div className="checkbox-wrapper-mail">
                                <Input type="checkbox" id={inbox.id} />
                                <Label htmlFor={inbox.id} className="toggle" />
                              </div>
                              <Link to={`/email-read/${inbox.emailDetailId}`} className="title">
                                {inbox.to}
                              </Link>
                            </div>
                            <div className="col-mail col-mail-2">
                              <SafeHTML html={inbox.subject} />
                            
                              <div className="date">
                                {isToday
                                  ? createdOnDate.format('h:mm A') 
                                  : createdOnDate.format('MMM DD')}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                      </TabPane>
                    </TabContent>
                  </Card>
                  {/* Pagination Section */}
                  <Row>
                    <Col xs="7">
                      {/* Showing page info */}
                      Showing {inboxMails?.length > 0 ? `${(currentPage - 1) * 20 + 1} - ${currentPage * inboxMails?.length} of ${totalPages * 20}` : "No emails"} 
                    </Col>
                    <Col xs="5">
                      <div className="btn-group float-end">
                        {/* Previous Button */}
                        <Button
                          type="button"
                          color="success"
                          size="sm"
                          onClick={this.handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          <i className="fa fa-chevron-left" />
                        </Button>

                        {/* Next Button */}
                        <Button
                          type="button"
                          color="success"
                          size="sm"
                          onClick={this.handleNextPage}
                          disabled={currentPage === totalPages}
                        >
                          <i className="fa fa-chevron-right" />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

EmailSent.propTypes = {
  activeTab: PropTypes.string,
 
}

const mapStateToProps = ({ Mails }) => ({

})

const mapDispatchToProps = dispatch => ({

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EmailSent))